import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const TextStrikethroughIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="textStrikethrough" ref={ref} {...props}>
    <path d="M18.529,14.9a4.252,4.252,0,0,1,.21,1.329,4.606,4.606,0,0,1-4.72,4.49H6.769v.25a.75.75,0,0,1-1.5,0v-4a.75.75,0,0,1,1.5,0v2.25h7.25a3.111,3.111,0,0,0,3.22-2.99,2.826,2.826,0,0,0-.13-.87.746.746,0,1,1,1.42-.459ZM21,11.71H10.039a3.162,3.162,0,0,1-3.25-3.091,3.15,3.15,0,0,1,3.25-3.02h7.2v2.25a.75.75,0,0,0,1.5,0v-4a.75.75,0,0,0-1.5,0V4.1h-7.2A4.659,4.659,0,0,0,5.289,8.69a4.32,4.32,0,0,0,1.23,3.02H3.009a.742.742,0,0,0-.75.75.75.75,0,0,0,.75.75H21a.756.756,0,0,0,.75-.75A.748.748,0,0,0,21,11.71Z" />
  </Icon>
)) as IconWithRender;

TextStrikethroughIcon.displayName = 'TextStrikethroughIcon';
TextStrikethroughIcon.renderIcon = (props) => (
  <TextStrikethroughIcon {...props} />
);
export default TextStrikethroughIcon;
